export enum Brand {
  BOS = 'bos',
  HALIFAX = 'halifax',
  LLOYDS = 'lloyds',
  MBNA = 'mbna',
  SCOTTISH_WIDOWS = 'scottish-widows',
  BIRMINGHAM_MIDSHIRES = 'birmingham-midshires',
  BLACK_HORSE = 'black-horse',
}
